import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const statisticsApi = createApi({
  reducerPath: 'statistics',


  baseQuery: createBaseQueryWithReauth('/statistics'),

  tagTypes: ['Statistics'],

  endpoints: builder => ({
    getGeneral: builder.query({
      query: ({period,user_id} ) => ({
        url: `/general?period=${period}&user_id=${user_id}`,
        method: 'GET',
      }),

      providesTags: ['Statistics'],
    }),

    getRating: builder.query({
      query: ({ count, type,user_id  }) => ({
        url: `/rating?count=${count}&type=${type}&user_id=${user_id}`,
        method: 'GET',
      }),

      providesTags: ['Statistics'],
    }),
    getCancelled: builder.query({
      query: ({ count, type,user_id }) => ({
        url: `/cancelled?count=${count}&type=${type}&user_id=${user_id}`,
        method: 'GET',
      }),

      providesTags: ['Statistics'],
    }),
    getReverted: builder.query({
      query: ({ count, type,user_id  }) => ({
        url: `/reverted?count=${count}&type=${type}&user_id=${user_id}`,
        method: 'GET',
      }),

      providesTags: ['Statistics'],
    }),
    // getFeedbacks: builder.query({
    //   query: (period) => ({
    //     url: `/feedbacks?period=${period}`,
    //     method: 'GET',
    //   }),

    //   providesTags: ['Statistics'],
    // }),
    getFeedbacks: builder.query({
      query: ({ period, user_id }) => ({
        url: period ? `/feedbacks?period=${period}&user_id=${user_id}` : `/feedbacks?user_id=${user_id}`, // Додаємо параметр тільки якщо period присутній
        method: 'GET',
      }),

      providesTags: ['Statistics'],
    }),

    getComments: builder.query({
      query: ({ period, user_id,  page = 1 } = {}) => {
        const params = {
          page, // додаємо параметр page до запиту
          period
        };
        return {
          url: period ? `/comments?period=${period}&user_id=${user_id}` : `/comments?user_id=${user_id}`, // Додаємо параметр тільки якщо period присутній
          method: 'GET',
          params,
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
        return { data: response, pagination };
      },
      providesTags: ['Statistics'],
    }),

  }),
});

export const {
  useGetGeneralQuery,
  useGetRatingQuery,
  useGetCancelledQuery,
  useGetRevertedQuery,
  useGetFeedbacksQuery,
  useGetCommentsQuery
} = statisticsApi;
